import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import {
  Form as FormUi,
  Container, TextArea, Dropdown
} from "semantic-ui-react";
import ReadAxios from "../../../components/axiosComponent/read";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import CreateAxios from "../../../components/axiosComponent/create";
import UpdateAxios from "../../../components/axiosComponent/update";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { AllRegex } from "../../../utils/validation";
import { ERROR_MESSAGES, INVALID_FIELDS, REQUIRED_FIELDS } from "../../../utils/validationConstant";
import {LOCAL_STORAGE} from '../../../utils/constant'
import {LABELS, PLACE_HOLDERS, BUTTONS} from './yardConstants'
import cogoToast from "cogo-toast";
import MyCity from "../../../components/apiInputs/myCity";

const currentUser = LOCAL_STORAGE.customerNo

const InsertYard = ({ values, setFieldValue, touched, errors, t, ...props }) => {

  return (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="ml-3 mr-3 mt-5 mb-5 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
              <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.yard_code||"Yard Code"}
                  </label>
                </FormUi.Field>
              <FormUi.Field width={4} error={touched.yardCode && errors.yardCode ? true : false} >
              <div className="container">
              <div className="row">
                <Fieldmik
                type="text"
                className="ui input pe-5"
                name="yardCode"
                placeholder={PLACE_HOLDERS.yard_code||"Enter Yard Code"}
              />
              </div>
              <div className="row">
                      {touched.yardCode && errors.yardCode ? (
                        <div className="error-msg">
                          {errors.yardCode}
                        </div>
                      ) : null}
                    </div>
                    </div>
              </FormUi.Field>
              <FormUi.Field width={1}></FormUi.Field>
                <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.yard||"Yard Name"}<span className="red"> *</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.yardName && errors.yardName ? true : false}>
                  <div className="container">
                    <div className="row">
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="yardName"
                        placeholder={PLACE_HOLDERS.yard||"Enter Yard Name"}
                        />
                    </div>
                    <div className="row">
                      {touched.yardName && errors.yardName ? (
                        <div className="error-msg">
                          {errors.yardName}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
              <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.checkpoint_latitude||"Checkpoint Latitude"}
                  </label>
                </FormUi.Field>
              <FormUi.Field width={4} error={touched.checkPointLattitude && errors.checkPointLattitude ? true : false}>
              <div className="container">
              <div className="row">
                <Fieldmik
                type="number"
                className="ui input pe-5"
                name="checkPointLattitude"
                placeholder={PLACE_HOLDERS.checkpoint_latitude||"Enter Checkpoint Latitude"}
              />
              </div>
              <div className="row">
                      {touched.checkPointLattitude && errors.checkPointLattitude ? (
                        <div className="error-msg">
                          {errors.checkPointLattitude}
                        </div>
                      ) : null}
                    </div>
                    </div>
              </FormUi.Field>
              <FormUi.Field width={1}></FormUi.Field>
                <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.checkpoint_longitude||"Checkpoint Longitude"}
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.checkPointLongitude && errors.checkPointLongitude ? true : false}>
                  <div className="container">
                    <div className="row">
                      <Fieldmik
                        type="number"
                        className="ui input"
                        name="checkPointLongitude"
                        placeholder={PLACE_HOLDERS.checkpoint_longitude||"Enter Checkpoint Longitude"}
                        />
                    </div>
                    <div className="row">
                      {touched.checkPointLongitude && errors.checkPointLongitude ? (
                        <div className="error-msg">
                          {errors.checkPointLongitude}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.checkpoint_radius||"Checkpoint Radius"}
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.checkPointRadius && errors.checkPointRadius ? true : false}>
                  <div className="container">
                    <div className="row">
                      <Fieldmik
                        type="number"
                        className="ui input"
                        name="checkPointRadius"
                        placeholder={PLACE_HOLDERS.checkpoint_radius||"Enter Checkpoint Radius."}
                        />
                    </div>
                    <div className="row">
                      {touched.checkPointRadius && errors.checkPointRadius ? (
                        <div className="error-msg">
                          {errors.checkPointRadius}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </FormUi.Field>

                <FormUi.Field width={1}></FormUi.Field>
                <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.city||"City"}
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.cityId && errors.cityId ? true : false}>
                  <div className="container">
                    <div className="row">
                      <Fieldmik
                        name="cityId"
                        placeholder={values.cityName || PLACE_HOLDERS.city||"Select City"}
                        component={MyCity}
                        clearable
                        />
                    </div>
                    <div className="row">
                      {touched.cityId && errors.cityId ? (
                        <div className="error-msg">
                          {errors.cityId}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </FormUi.Field>
              </FormUi.Group>
            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {BUTTONS.submit||"Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  );
};

const FormikYard = withFormik({
  validationSchema: yup.object({
    yardName: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(30, ERROR_MESSAGES.MAX_LENGTH(30)),
    checkPointRadius: yup.number().test('checkpointRadius', INVALID_FIELDS.INVALID_RADIUS, value => AllRegex.INT_OR_DECIMAL_WITH_MAX_5_DIGITS.test(value) && value <= 50),
    checkPointLongitude :  yup.string().optional().matches(AllRegex.Longitude, INVALID_FIELDS.INVALID_LONGITUDE), 
    checkPointLattitude : yup.string().optional().matches(AllRegex.Latitude, INVALID_FIELDS.INVALID_LATITUDE),
    cityId : yup.string().optional()
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
        yardName: props.editData.yardName || "",
        yardCode: props.editData.yardCode || "",
        checkPointLattitude: props.editData.checkPointLattitude || "",
        checkPointLongitude: props.editData.checkPointLongitude || "",
        checkPointRadius: props.editData.checkPointRadius || "",
        checkPointMasterId : props?.editData?.checkPointMasterId || "",
        cityId : props?.editData?.cityId || "",
        cityName : props?.editData?.cityName || ""
    };
  },
  async handleSubmit(values, { props, resetForm }) {
    if (props.editData.yardId) {
      UpdateAxios({
        url: "yard",
        payload: { ...values },
        uniqueId: props.editData.yardId,
      })
        .then((res) => {
          if(res?.data?.status===200){
            cogoToast.success(res?.data?.message, { position: 'top-right' });
            setTimeout(() => {
              props.onFormSubmit();
            }, 500);
          }else{
            cogoToast.error(res?.data?.message, { position: 'top-right' });
          }
          
        })
        .catch((err) => {
            cogoToast.error(err?.data?.message, { position: 'top-right' });
          
        });
    } else {
      CreateAxios({
        url: "yard",
        payload: { ...values },
      })
        .then((res) => {
          if(res?.data?.status == 204){
            cogoToast.error(res?.data?.message, { position: 'top-right' });
          }else{
            cogoToast.success(res?.data?.message, { position: 'top-right' });
            setTimeout(() => {
              props.onFormSubmit();
            }, 500);
          }        
        })
        .catch((err) => {
          console.log("error yard", err);
          cogoToast.error(err?.data?.message, { position: 'top-right' });
        });
    }
  },
})(InsertYard);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("yard")(FormikYard)
);
